/* ZSportsTech — section-video.js
   Scoped to #sc-ztank (The Z Story · §07 Shark Tank poster → video).
   Click the play button / watch link → open a focus-trapped lightbox with
   the pitch embed. ESC + backdrop close, reduced-motion aware. Vanilla JS.
   Maps to → assets/section-video.js in the Shopify theme.
   ─────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var section = document.getElementById('sc-ztank');
  if (!section) return;

  var openers = section.querySelectorAll('[data-video-open]');
  var lb       = section.querySelector('#sc-ztank-lightbox');
  var inner    = lb ? lb.querySelector('.sc-ztank__lb-inner') : null;
  var closeBtn = lb ? lb.querySelector('#sc-ztank-lb-close') : null;
  if (!openers.length || !lb || !inner || !closeBtn) return;

  // DYNAMIC: settings.video_url — embed URL for the pitch
  var EMBED = section.getAttribute('data-video-embed') || '';
  var lastFocused = null;

  function getFocusable() {
    return lb.querySelectorAll('button, a[href], iframe, [tabindex]:not([tabindex="-1"])');
  }

  function open() {
    lastFocused = document.activeElement;
    if (EMBED && !inner.querySelector('iframe')) {
      var f = document.createElement('iframe');
      f.src = EMBED + (EMBED.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
      f.title = 'Shark Tank India: the Z-Bat pitch';
      f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      f.allowFullscreen = true;
      inner.insertBefore(f, closeBtn);
    }
    lb.hidden = false;
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
    document.addEventListener('keydown', onKey);
  }

  function close() {
    lb.hidden = true;
    document.body.style.overflow = '';
    var f = inner.querySelector('iframe');
    if (f) f.remove(); // stop playback
    document.removeEventListener('keydown', onKey);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function onKey(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = getFocusable();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  openers.forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); open(); });
  });
  closeBtn.addEventListener('click', close);
  lb.addEventListener('click', function (e) { if (e.target === lb) close(); });

}());
